<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="库区名称">
        <el-input maxlength='450' v-model="formInline.regionName" placeholder="库区名称" @change="$emit('search', formInline)"></el-input>
      </el-form-item>
      <el-form-item label="负责人">
        <el-input maxlength='450' v-model="formInline.regionContact" placeholder="负责人" @change="$emit('search', formInline)"></el-input>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
            v-model="formInline.date"
            @change="dateChange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-left: 30px" type="primary" @click="$emit('search', formInline)">搜索</el-button>
        <el-button style="margin-left: 10px" @click="rest">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "Form",
  data() {
    return {
      formInline: {
        areaName: '',
        principal: '',
        date: [],
        createStartTime: null,
        createEndTime: null
      }
    }
  },
  mounted() {
    this.$emit('search', this.formInline)
  },
  methods: {
    dateChange: function (date) {
      // console.log(val)
      if (!date) {
        this.formInline.createStartTime = null
        this.formInline.createEndTime = null
        return
      }
      this.formInline.createStartTime = date[0].getTime();
      this.formInline.createEndTime = date[1].getTime();
      this.$emit('search', this.formInline)
    },
    rest: function () {
      this.formInline = {
        regionName: '',
        regionContact: '',
        date: [],
        createStartTime: null,
        createEndTime: null
      }
      this.$emit('search', this.formInline)
    }
  }
}
</script>

<style scoped>

</style>